<template>
  <div class="circular-calculation-state-loader">
    <p>{{ showCalculationState }}</p>
    <v-progress-circular
      v-if="calculationState.progress > 0"
      :value="calculationState.progress"
      :size="size"
      :width="5"
      color="primary"
      class="mt-2"
    >
      <span>{{ calculationState.progress }}%</span>
    </v-progress-circular>
    <v-progress-circular
      v-else
      :size="size"
      :width="5"
      indeterminate
      color="primary"
      class="mt-2"
    >
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "CircularCalculationStateLoader",
  props: {
    calculationState: {
      type: Object,
    },
    size: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    showCalculationState() {
      if (this.calculationState.stateValue == 0) {
        return this.calculationState.stateTitle;
      } else if (
        this.calculationState == undefined ||
        this.calculationState == ""
      ) {
        return "";
      } else {
        return `${this.calculationState.stateTitle}`;
      }
    },
  },
};
</script>


<style scoped>
.circular-calculation-state-loader {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circular-calculation-state-loader p {
  margin: 8px 0;
  font-size: 14px;
  color: #333;
}
</style> 